import { useLang } from '../context/LanguageContext';
import './FooterTestimonials.css';

const ITEMS = [
  { id: 1, textKey: 'testimonial1', authorKey: 'testimonial1Author', locationKey: 'testimonial1Location', initial: 'R' },
  { id: 2, textKey: 'testimonial2', authorKey: 'testimonial2Author', locationKey: 'testimonial2Location', initial: 'L' },
  { id: 3, textKey: 'testimonial3', authorKey: 'testimonial3Author', locationKey: 'testimonial3Location', initial: 'S' },
  { id: 4, textKey: 'testimonial4', authorKey: 'testimonial4Author', locationKey: 'testimonial4Location', initial: 'P' },
];

function TestimonialCard({ item, t }) {
  return (
    <article className="footer-testimonials__card" aria-hidden={item.duplicate || undefined}>
      <span className="footer-testimonials__quote" aria-hidden>
        “
      </span>
      <span className="footer-testimonials__stars" aria-hidden>
        ★★★★★
      </span>
      <p className="footer-testimonials__text">{t[item.textKey]}</p>
      <footer className="footer-testimonials__meta">
        <span className="footer-testimonials__avatar" aria-hidden>
          {item.initial}
        </span>
        <span className="footer-testimonials__who">
          <cite className="footer-testimonials__author">{t[item.authorKey]}</cite>
          <span className="footer-testimonials__location">{t[item.locationKey]}</span>
        </span>
      </footer>
    </article>
  );
}

export default function FooterTestimonials() {
  const { t } = useLang();
  const loop = [...ITEMS, ...ITEMS.map((i) => ({ ...i, id: `${i.id}-dup`, duplicate: true }))];

  return (
    <div className="footer-testimonials" aria-labelledby="footer-testimonials-label">
      <div className="footer-testimonials__head">
        <span className="footer-testimonials__eyebrow">{t.testimonialsEyebrow}</span>
        <h2 id="footer-testimonials-label" className="footer-testimonials__title">
          {t.testimonialsTitle}
        </h2>
      </div>

      <div className="footer-testimonials__viewport">
        <div className="footer-testimonials__fade footer-testimonials__fade--left" aria-hidden />
        <div className="footer-testimonials__fade footer-testimonials__fade--right" aria-hidden />
        <div className="footer-testimonials__track">
          <div className="footer-testimonials__scroll">
            {loop.map((item) => (
              <TestimonialCard key={item.id} item={item} t={t} />
            ))}
          </div>
        </div>
      </div>

      <ul className="footer-testimonials__sr" aria-label={t.testimonialsTitle}>
        {ITEMS.map((item) => (
          <li key={item.id}>
            {t[item.textKey]} — {t[item.authorKey]}, {t[item.locationKey]}
          </li>
        ))}
      </ul>
    </div>
  );
}
